var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, OnInit } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/AppConsts';
var StackedFooterComponent = /** @class */ (function (_super) {
    __extends(StackedFooterComponent, _super);
    function StackedFooterComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.remoteServiceBaseUrl = AppConsts.remoteServiceBaseUrl;
        return _this;
    }
    StackedFooterComponent.prototype.ngOnInit = function () {
        this.releaseDate = this.appSession.application.releaseDate.format('YYYYMMDD');
    };
    return StackedFooterComponent;
}(AppComponentBase));
export { StackedFooterComponent };
